import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@mui/material";
import { DialogModal } from "@zfp-akademie-a-s/zfp-design";
import { FormTextField } from "@zfp-akademie-a-s/zfp-design/form";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";

type ChangeReasonFormType = {
  reason: string;
};

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
};

const MIN_TEXT_LENGTH = 15;
const MAX_TEXT_LENGTH = 300;

export const QuestionnaireChangeReasonModal = ({ isOpen, onClose, onConfirm }: Props) => {
  const { t } = useResource();
  const r = Resources.Questionnaire.ChangeReasonModal;

  const schema = yup.object({
    reason: yup
      .string()
      .trim()
      .required(t(Resources.Validation.Required))
      .min(MIN_TEXT_LENGTH, t(Resources.Validation.String.Min, { count: MIN_TEXT_LENGTH }))
      .max(MAX_TEXT_LENGTH, t(Resources.Validation.String.Max, { count: MAX_TEXT_LENGTH })),
  });

  const methods = useForm<ChangeReasonFormType>({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: { reason: "" },
  });

  const { control, handleSubmit, reset } = methods;

  const handleClose = () => {
    reset({ reason: "" });
    onClose();
  };

  const onSubmit = (data: ChangeReasonFormType) => {
    onConfirm(data.reason);
    reset({ reason: "" });
  };

  return (
    <FormProvider {...methods}>
      <DialogModal
        open={isOpen}
        onClose={handleClose}
        closeLabel={t(Resources.Common.Close)}
        title={t(r.Title)}
        subtitle={t(r.Subtitle)}
        onSubmit={handleSubmit(onSubmit)}
        content={
          <FormTextField
            control={control}
            name="reason"
            label={t(r.Reason)}
            maxLength={MAX_TEXT_LENGTH}
            minLength={MIN_TEXT_LENGTH}
            multiline
            rows={4}
            fullWidth
          />
        }
        primaryAction={
          <Button variant="contained" type="submit">
            {t(Resources.Common.Continue)}
          </Button>
        }
      />
    </FormProvider>
  );
};
